// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1OAuthTokenRequestSchema = z.object({
  grant_type: z.enum(["authorization_code", "refresh_token"]).describe("OAuth 2.0 grant type"),
  client_id: z.coerce.string().min(1).describe("OAuth 2.0 client identifier"),
  client_secret: z.coerce.string().min(1).describe("OAuth 2.0 client secret"),
  code: z.coerce.string().describe("Authorization code (required for authorization_code grant)").nullish(),
  redirect_uri: z.coerce.string().describe("Redirect URI (required for authorization_code grant)").nullish(),
  refresh_token: z.coerce.string().describe("Refresh token (required for refresh_token grant)").nullish(),
});
